/* FootDrop visual search worker — hardened 2026-09-18 */
var MP=null,META=null,IDX=null,ROWS=null;

async function importTransformers(){
  var urls=[
    'https://cdn.jsdelivr.net/npm/@huggingface/transformers@4.2.0',
    'https://cdn.jsdelivr.net/npm/@huggingface/transformers@3.8.1'
  ],last;
  for(var i=0;i<urls.length;i++){
    try{return await import(urls[i]);}catch(e){last=e;}
  }
  throw last||new Error('transformers_import_failed');
}
async function loadModel(T,cfg,prog){
  var last;
  var devices=(self.navigator&&self.navigator.gpu)?['webgpu','wasm']:['wasm'];
  /* MobileCLIP's own Transformers.js config specifies fp32 for the vision model.
     Respect that first; quantized vision is last-resort only. */
  for(var i=0;i<devices.length;i++){
    try{
      var device=devices[i];
      var model=await T.CLIPVisionModelWithProjection.from_pretrained(cfg.model,{device:device,progress_callback:prog});
      return {model:model,device:device,dtype:'model-default'};
    }catch(e){last=e;}
  }
  var fallbacks=[];
  if(self.navigator&&self.navigator.gpu)fallbacks.push({device:'webgpu',dtype:'fp32'});
  fallbacks.push({device:'wasm',dtype:'fp32'});
  if(self.navigator&&self.navigator.gpu)fallbacks.push({device:'webgpu',dtype:'fp16'});
  fallbacks.push({device:'wasm',dtype:'q8'});
  for(i=0;i<fallbacks.length;i++){
    try{
      var a=fallbacks[i];
      var m=await T.CLIPVisionModelWithProjection.from_pretrained(cfg.model,{device:a.device,dtype:a.dtype,progress_callback:prog});
      return {model:m,device:a.device,dtype:a.dtype};
    }catch(e2){last=e2;}
  }
  throw last||new Error('model_load_failed');
}
async function load(cfg){
  ['meta','idx','rows'].forEach(function(k){
    if(!(String(cfg[k]||'').startsWith('https://')||String(cfg[k]||'').startsWith('http://')))throw new Error('invalid_asset_url_'+k);
  });
  var T=await importTransformers(),last=-1;
  function prog(e){
    if(e&&e.status==='progress'&&e.total){
      var p=Math.round(e.loaded/e.total*100);
      if(p!==last){last=p;postMessage({t:'dl',p:p});}
    }
  }
  var processor=await T.AutoProcessor.from_pretrained(cfg.model,{progress_callback:prog});
  var mm=await loadModel(T,cfg,prog);
  var r=await Promise.all([
    fetch(cfg.meta).then(function(x){if(!x.ok)throw new Error('meta_http_'+x.status);return x.json();}),
    fetch(cfg.idx).then(function(x){if(!x.ok)throw new Error('index_http_'+x.status);return x.arrayBuffer();}),
    fetch(cfg.rows).then(function(x){if(!x.ok)throw new Error('rows_http_'+x.status);return x.arrayBuffer();})
  ]);
  META=r[0];IDX=new Int8Array(r[1]);ROWS=new Uint16Array(r[2]);
  if(!Array.isArray(META)||!META.length||!ROWS.length||IDX.length!==ROWS.length*512)throw new Error('invalid_index');
  for(var i=0;i<ROWS.length;i++)if(ROWS[i]>=META.length)throw new Error('invalid_index_row');
  postMessage({t:'ready',device:mm.device,dtype:mm.dtype});
  return {T:T,processor:processor,model:mm.model,device:mm.device,dtype:mm.dtype};
}
function scoreCatalogue(Q){
  var P=META.length,best=new Float32Array(P),second=new Float32Array(P),i,k,j;
  for(i=0;i<P;i++){best[i]=-1e9;second[i]=-1e9;}
  for(i=0;i<ROWS.length;i++){
    var o=i*512,pi=ROWS[i],scores=[];
    for(k=0;k<Q.length;k++){
      var q=Q[k],s=0;
      for(j=0;j<512;j++)s+=q[j]*IDX[o+j];
      scores.push(s);
    }
    scores.sort(function(a,b){return b-a;});
    var s0=scores.length?scores[0]:-1e9;
    var s1=scores.length>1?scores[1]:s0;
    var s2=scores.length>2?scores[2]:s1;
    var robust=s0*.78+s1*.16+s2*.06;
    if(robust>best[pi]){second[pi]=best[pi];best[pi]=robust;}
    else if(robust>second[pi])second[pi]=robust;
  }
  for(i=0;i<P;i++)if(second[i]>-1e8&&best[i]>0)best[i]+=Math.max(0,second[i])*.035;
  var order=[];
  for(i=0;i<P;i++)if(best[i]>-1e8&&META[i]&&META[i][0])order.push(i);
  order.sort(function(a,b){return best[b]-best[a];});
  var items=[];
  for(i=0;i<order.length&&items.length<48;i++)items.push(META[order[i]]);
  return items;
}
onmessage=async function(ev){
  var d=ev.data||{};
  try{
    if(d.t==='init'){
      MP=MP||load(d.cfg);
      await MP;
      return;
    }
    if(d.t==='search'){
      MP=MP||load(d.cfg);
      var M=await MP;
      postMessage({t:'stage',n:2});
      var maxRegions=M.device==='webgpu'?6:4;
      var regions=(d.regions||[]).slice(0,maxRegions),Q=[];
      if(!regions.length)throw new Error('no_regions');
      for(var k=0;k<regions.length;k++){
        postMessage({t:'infer',i:k+1,total:regions.length});
        var img=new M.T.RawImage(new Uint8ClampedArray(regions[k]),256,256,4);
        var inputs=await M.processor(img);
        var out=await M.model(inputs);
        var e=out.image_embeds&&out.image_embeds.data;
        if(!e||e.length!==512)throw new Error('invalid_embedding');
        var n=0,j;
        for(j=0;j<512;j++){var xv=e[j];n+=xv*xv;}
        if(!Number.isFinite(n)||n<=0)throw new Error('invalid_embedding');
        n=Math.sqrt(n);
        var q=new Float32Array(512);
        for(j=0;j<512;j++)q[j]=e[j]/n;
        Q.push(q);
      }
      postMessage({t:'stage',n:3});
      postMessage({t:'results',token:d.token,items:scoreCatalogue(Q)});
    }
  }catch(err){
    MP=null;META=null;IDX=null;ROWS=null;
    postMessage({t:'err',msg:String(err&&err.message||err),token:d.token});
  }
};